import { render, staticRenderFns } from "./SuppressIssuePopup.vue?vue&type=template&id=9b04b020"
import script from "./SuppressIssuePopup.vue?vue&type=script&lang=js"
export * from "./SuppressIssuePopup.vue?vue&type=script&lang=js"
import style0 from "./SuppressIssuePopup.vue?vue&type=style&index=0&id=9b04b020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports